<p-card *ngIf="entityLoaded && existsAvaiableParameters" [title]="title">
    <div class="p-fluid p-grid">
        <div *ngIf="existsAvaiableParameters&&!existsArea&&!existsDistrict" class="p-col-12">
            <p>Wybierz checklistę oraz podaj okres z którego mają być pokazane dane</p>
        </div>
        <div *ngIf="existsAvaiableParameters&&existsArea&&existsDistrict" class="p-col-12">
            <p>Wybierz checklistę, okręg, rejon oraz podaj okres z którego mają być pokazane dane</p>
        </div>
    </div>

    <div class="p-fluid">
        <div class="p-field p-col" *ngIf="existsAvaiableParameters&&dataexist">
            <span class="p-float-label">
                <p-dropdown inputId="projectGuid" [autoDisplayFirst]="false" [options]="projectGuids.values" [(ngModel)]="projectGuid" optionLabel="label" optionValue="value"></p-dropdown>
                <label for="projectGuid">Tura audytów</label>
            </span>
        </div>
        <div class="p-field p-col" *ngIf="existsAvaiableParameters&&existsArea&&existsDistrict">
            <span class="p-float-label">
                <p-cascadeSelect [(ngModel)]="selectedLocation" [options]="locations" optionLabel="label" optionGroupLabel="label" [optionGroupChildren]="['districts', 'areas']" ></p-cascadeSelect>
                <!-- <p-dropdown inputId="region" [autoDisplayFirst]="false" [options]="regions.values" [(ngModel)]="region" optionLabel="label" optionValue="value"></p-dropdown> -->
                <label for="region">Obszar</label>
            </span>
        </div>
        <div class="p-field p-col" *ngIf="existsAvaiableParameters&&dataexist">
            <span class="p-float-label">
                <p-calendar inputId="calendar" [(ngModel)]="dateRange" selectionMode="range" [readonlyInput]="true" [showIcon]="true"></p-calendar>
                <label for="calendar">Zakres dat</label>
            </span>
        </div>
        
    </div>
    <div class="p-fluid p-grid" *ngIf="existsAvaiableParameters&&dataexist">
        <div class="p-col-12">
            <button class="p-mr-2" nbButton status="primary" size="small" (click)="download()" i18n>Download</button>
            <button class="p-mr-2" nbButton status="basic" size="small" (click)="refreshAndRedraw()" i18n>Refresh</button>
        </div>
    </div>
</p-card>
<p-card *ngIf="!entityLoaded" header="Loading..." i18n-header>
    <fa-icon [icon]="['fas', 'spinner']" [spin]='true' size="lg"></fa-icon>
</p-card>

<!-- 
<nb-card *ngIf="entityLoaded" size="xsmall" class="spinner-report" [nbSpinner]="this.generatingInProgress"
    [nbSpinnerStatus]="'primary'"
    [nbSpinnerMessage]="'Proszę czekać, trwa generowanie raportu. To może potrwać kilka miniut...'">
    <nb-card-header>
        <span>{{title}}</span>

    </nb-card-header>
    <nb-card-body *ngIf="dataexist">
        <-- <input matInput type="text"
        [matDatepicker]="picker" style="visibility: hidden;width: 0px;margin: 0;padding: 0;border:0">
        <button nbButton status="basic" (click)="download()" [nbSpinner]="generatingInProgress" nbSpinnerStatus="basic" >{{ month | date:'LLLL y' }}</button>
        <button nbButton status="success" (click)="picker.open()" ><nb-icon icon="calendar-outline"></nb-icon></button>
        <mat-datepicker #picker
                  startView="year"
                  (yearSelected)="chosenYearHandler($event)"
                  (monthSelected)="chosenMonthHandler($event, picker)">
        </mat-datepicker> --
        <div class="row mt-2">
            
        </div>
        <div *ngIf="existsAvaiableParameters&&dataexist" class="row mt-3">
            <div class="col-12">
                <nb-select fullWidth placeholder="Wybierz checklistę" [(ngModel)]="projectGuid">
                    <nb-option *ngFor="let guid of projectGuids.values" [value]="guid.value">{{guid.label}}</nb-option>
                </nb-select>
            </div>
        </div>
        <div *ngIf="existsAvaiableParameters&&existsArea&&existsDistrict" class="row mt-3">
            <div *ngIf="existRegions" class="col-12 mb-3">
                <nb-select fullWidth placeholder="Wybierz region" [(ngModel)]="region">
                    <nb-option *ngFor="let region of regions.values" [value]="region.value">{{region.label}}</nb-option>
                </nb-select>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <input type="text" class="form-control" nbInput fullWidth placeholder="Okręg"
                        [(ngModel)]="district" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <input type="text" class="form-control" nbInput fullWidth placeholder="Rejon" [(ngModel)]="area" />
                </div>
            </div>
        </div>
        <div *ngIf="existsAvaiableParameters&&dataexist" class="row mt-3">
            <div class="col-12 form-group">
                <div class="mat-form-field">
                    <fa-icon nbPrefix (click)="picker.open()" [icon]="['fas', 'calendar-alt']"></fa-icon>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate placeholder="Start date"  [(ngModel)]="date.begin">
                        <input matEndDate placeholder="End date" [(ngModel)]="date.end">
                    </mat-date-range-input>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </div>
            </div>
        </div>
        <div *ngIf="existsAvaiableParameters&&dataexist" class="row mt-3 d-flex justify-content-between">
            <div class="col-6 col-sm-6 col-md-2 d-flex justify-content-start mb-2"><button nbButton status="primary"
                    size="small" (click)="reloadAndRedraw()">{{ 'Show' | i18next }}</button></div>
            <div class="col-6 col-sm-6 col-md-2  d-flex  justify-content-end mb-2"><button nbButton status="basic"
                    size="small" (click)="refreshAndRedraw()">{{ 'Refresh' | i18next }}</button></div>
        </div>
    </nb-card-body>
</nb-card> -->
<nb-card *ngIf="!entityLoaded">
    <nb-card-header>{{ 'Loading...' | i18next }}</nb-card-header>
    <nb-card-body>
        <fa-icon [icon]="['fas', 'spinner']" [spin]='true' size="lg"></fa-icon>
    </nb-card-body>
</nb-card>